import { useState } from 'react';

/**
 * Which entry a {@link ContentModal} is showing.
 *
 * The entry outlives the dialog's `open` flag on purpose: clearing it on close
 * would blank the body for the length of the fade-out, so it is dropped only
 * once the dialog has gone.
 */
export function useContentViewer<T>() {
	const [entry, setEntry] = useState<T | null>(null);
	const [open, setOpen] = useState(false);

	return {
		entry,
		open,
		view: (next: T) => {
			setEntry(next);
			setOpen(true);
		},
		close: () => setOpen(false),
		afterClose: () => setEntry(null),
	};
}
